import React, { useRef, useState } from 'react';
import '@maersk-global/mds-components-core/mc-modal';
import '@maersk-global/mds-components-core/mc-button';
import './Feedbackstyle.css';
import { McRadio } from "@maersk-global/mds-react-wrapper/components-core/mc-radio";
import { McInput } from "@maersk-global/mds-react-wrapper/components-core/mc-input";
import logo from "../../assets/images/maersk-logo.png";

const Feedback = () => {
  const modalRef = useRef(null);
  const [selectedOption, setSelectedOption] = useState(''); 

  const openModal = () => {
    if (modalRef.current) modalRef.current.open = true;
  };

  const closeModalAndReset = () => {
    if (modalRef.current) modalRef.current.open = false;
    setSelectedOption('');
  };

  const handleSave = () => {
    closeModalAndReset();
  };

  const handleSelect = (value) => {
    setSelectedOption(value);
  };

  return (
    <div>
      <div className="Feedbackbutton" onClick={openModal}>
        Feedback
      </div>

      <mc-modal ref={modalRef} height="59vh" width="35vw">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
          <img
            src={logo}
            alt="Maersk"
            style={{ height: 36, width: 'auto', objectFit: 'contain' }}
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
          <h3 style={{ margin: 0 }}>We value your input</h3>
        </div>

        <p style={{ marginTop: 8, marginBottom: 8, fontWeight: 600 }}>
          What would you like to do today?
        </p>

        <div className="feedback-radio-group" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <McRadio
            name="feedbackOption"
            label="Share feedback or suggestions to improve your web experience."
            value="feedback"
            checked={selectedOption === 'feedback'}
            // attach both handlers to be safe depending on component implementation
            onChange={() => handleSelect('feedback')}
            onClick={() => handleSelect('feedback')}
          />

          <McRadio
            name="feedbackOption"
            label="Report an issue with this page of the website."
            value="issue"
            checked={selectedOption === 'issue'}
            onChange={() => handleSelect('issue')}
            onClick={() => handleSelect('issue')}
          />
        </div>

        {/* Conditionally render the inputs */}
        <div style={{ marginTop: 16 }}>
          {selectedOption === 'feedback' && (
            <McInput
              key="feedbackInput"
              label="Share Feedback / Suggestions"
              placeholder="Type your feedback here"
              name="feedbackInput"
              fit='small'
              textarea
              rows={4}
            />
          )}

          {selectedOption === 'issue' && (
            <McInput
              key="issueInput"
              label="What issue are you experiencing with this webpage?"
              placeholder="Describe the issue here"
              name="issueInput"
              fit='small'
              textarea
              rows={4}
            />
          )}
        </div>

        <div style={{ margin: 24 , display: 'flex', justifyContent: 'flex-end' }}>
          <mc-button
            slot="secondaryAction"
            appearance="neutral"
            variant="outlined"
            dialogaction="cancel"
            onClick={closeModalAndReset} // make sure Cancel closes & resets
          >
            Cancel
          </mc-button>

          <mc-button
            slot="primaryAction"
            appearance="primary"
            dialogaction="ok"
            onClick={handleSave}
            style={{ marginLeft: 8 }}
          >
            Save
          </mc-button>
        </div>
      </mc-modal>
    </div>
  );
};

export default Feedback;
